function bootstrapFeLoginCaptcha() {
	if (window.__feLoginCaptchaBooted) {
		return;
	}
	window.__feLoginCaptchaBooted = true;

	const hasLoginForm = Boolean($(".form-login").length || $("#login_email").length || $("#login_password").length);
	if (!hasLoginForm) {
		return;
	}

	let captchaMode = "none";
	let googleSiteKey = "";
	let loginCallPatched = false;

	function debugLog() {}

	function debugWarn() {}

	function safeLoginStatus(message, color) {
		if (window.login && typeof window.login.set_status === "function") {
			window.login.set_status(message, color);
		}
	}

	function normalizeCaptchaContainers() {
		const $containers = $("#captcha-container");
		if ($containers.length <= 1) {
			return;
		}
		const $visible = $containers.filter(":visible");
		const $keep = $visible.length ? $visible.first() : $containers.first();
		$containers.not($keep).remove();
	}

	function ensureLocalCaptchaContainer() {
		normalizeCaptchaContainers();
		if (!$("#captcha-container").length) {
			debugLog("Creating local captcha container");
			const html = `
				<div id="captcha-container" style="margin: 10px 0;">
					<span id="captchaId" class="hide"></span>
					<div id="captcha-img-card" style="display:flex; align-items:center; gap:8px; margin-bottom:8px;">
						<img alt="captcha" id="captcha-image" style="max-width: 220px;" />
						<span id="refresh-card" style="cursor:pointer;">Refresh</span>
					</div>
					<div id="captcha-user-card">
						<input type="text" class="form-control" placeholder="Enter Captcha" id="captchaUserInput" />
					</div>
					<div id="fe-login-captcha-message" style="margin-top:8px; font-size:12px; color:#d94f4f;"></div>
				</div>
			`;
			$("body").append(html);
		}

		const $container = $("#captcha-container").first();
		const $otpForm = $(".form-verify:visible");
		if ($otpForm.length) {
			const $otpButton = $otpForm.find("#verify_token");
			if ($otpButton.length) {
				$container.insertBefore($otpButton);
			} else {
				$otpForm.append($container);
			}
		} else {
			const $actions = $(".for-login .page-card-actions:visible");
			if ($actions.length) {
				$actions.prepend($container);
			} else {
				const $loginForm = $(".form-login:visible");
				if ($loginForm.length) {
					$loginForm.append($container);
				}
			}
		}
		$container.removeClass("hide");
		debugLog("Local captcha container visible");
	}

	function bindRefreshHandler() {
		debugLog("Binding refresh handler");
		$(document).off("click.feLoginCaptcha", "#refresh-card");
		$(document).on("click.feLoginCaptcha", "#refresh-card", function (event) {
			event.preventDefault();
			debugLog("Refresh clicked -> calling captcha API");
			fetchLocalCaptcha(__("Captcha refreshed."));
		});
	}

	function fetchLocalCaptcha(message) {
		frappe.call({
			method: "frappe_extensions.captcha.get_captcha",
			type: "POST",
			callback: function (response) {
				debugLog("Refresh API response", {
					hasMessage: Boolean(response && response.message),
					hasCaptchaId: Boolean(response && response.message && response.message.captcha_id),
					hasImage: Boolean(response && response.message && response.message.image),
				});
				if (response && response.message && response.message.captcha_id && response.message.image) {
					showLocalCaptcha(response.message, message || __("Captcha is required."));
				}
			},
			error: function (error) {
				debugWarn("Refresh API failed", error);
				setCaptchaMessage(__("Unable to refresh captcha."));
			},
		});
	}

	function setCaptchaMessage(message) {
		if ($("#fe-login-captcha-message").length) {
			$("#fe-login-captcha-message").text(message || "");
		}
	}

	function showLocalCaptcha(captcha, message) {
		debugLog("Rendering local captcha", {
			captchaId: (captcha && captcha.captcha_id) || "",
			message: message || "",
		});
		ensureLocalCaptchaContainer();
		$("#captchaId").text(captcha.captcha_id || "");
		$("#captcha-image").attr("src", "data:image/png;base64," + captcha.image);
		$("#captchaUserInput").val("").focus();
		setCaptchaMessage(message || __("Captcha is required."));
	}

	function clearLocalCaptcha() {
		$("#captchaUserInput").val("");
	}

	function parseCaptchaPayload(data) {
		if (!data) {
			return null;
		}

		if (data.message && typeof data.message === "string") {
			try {
				const parsed = JSON.parse(data.message);
				if (parsed && parsed.captcha_required && parsed.captcha_id && parsed.image) {
					debugLog("Captcha payload parsed from message");
					return parsed;
				}
			} catch (error) {
				// ignore
			}
		}

		if (data._server_messages) {
			try {
				const serverMessages = JSON.parse(data._server_messages);
				for (const item of serverMessages) {
					const parsedItem = JSON.parse(item);
					const parsedMessage = JSON.parse(parsedItem.message || "{}");
					if (parsedMessage && parsedMessage.captcha_required && parsedMessage.captcha_id && parsedMessage.image) {
						debugLog("Captcha payload parsed from _server_messages");
						return parsedMessage;
					}
				}
			} catch (error) {
				// ignore
			}
		}

		return null;
	}

	function patchMsgprintForCaptcha() {
		if (!frappe || typeof frappe.msgprint !== "function" || frappe._feLoginCaptchaMsgprintPatched) {
			return;
		}
		frappe._feLoginCaptchaMsgprintPatched = true;
		const originalMsgprint = frappe.msgprint.bind(frappe);
		frappe.msgprint = function patchedMsgprint(msg, title, is_minimizable) {
			try {
				const raw = typeof msg === "string" ? msg : msg && typeof msg.message === "string" ? msg.message : "";
				if (raw) {
					const parsed = JSON.parse(raw);
					if (parsed && parsed.captcha_required && parsed.captcha_id && parsed.image) {
						showLocalCaptcha(parsed, parsed.message);
						return;
					}
				}
			} catch (error) {
				// ignore non-json messages
			}
			return originalMsgprint(msg, title, is_minimizable);
		};
	}

	function patchRequestCleanupForCaptcha() {
		if (!frappe || !frappe.request || typeof frappe.request.cleanup !== "function" || frappe._feLoginCaptchaCleanupPatched) {
			return;
		}
		frappe._feLoginCaptchaCleanupPatched = true;
		const originalCleanup = frappe.request.cleanup.bind(frappe.request);
		frappe.request.cleanup = function patchedCleanup() {
			const args = Array.prototype.slice.call(arguments);
			const response = args.find((item) => item && typeof item === "object" && (item.message || item._server_messages));
			const payload = parseCaptchaPayload(response);
			if (payload) {
				showLocalCaptcha(payload, payload.message);
				if (response) {
					response._server_messages = null;
					response._error_message = null;
				}
			}
			return originalCleanup.apply(this, args);
		};
	}

	function loadGoogleScript(siteKey) {
		return new Promise((resolve, reject) => {
			if (window.grecaptcha && window.grecaptcha.ready) {
				resolve();
				return;
			}

			const existing = document.querySelector("script[data-fe-login-captcha='google']");
			if (existing) {
				existing.addEventListener("load", () => resolve(), { once: true });
				existing.addEventListener("error", () => reject(new Error("Failed to load reCAPTCHA")), {
					once: true,
				});
				return;
			}

			const script = document.createElement("script");
			script.src = "https://www.google.com/recaptcha/api.js?render=" + siteKey;
			script.async = true;
			script.defer = true;
			script.dataset.feLoginCaptcha = "google";
			script.onload = () => resolve();
			script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));
			document.head.appendChild(script);
		});
	}

	function patchLoginCall() {
		if (!window.login || !window.login.call || loginCallPatched) {
			debugWarn("Skipping login.call patch", {
				hasLogin: Boolean(window.login),
				hasLoginCall: Boolean(window.login && window.login.call),
				loginCallPatched,
			});
			return;
		}
		loginCallPatched = true;
		debugLog("Patching window.login.call");

		const originalLoginCall = window.login.call.bind(window.login);
		window.login.call = function patchedLoginCall(args, callback, url) {
			const callArgs = args || {};
			const callUrl = url || "/";
			debugLog("patched login.call invoked", {
				cmd: callArgs.cmd,
				url: callUrl,
				mode: captchaMode,
				hasCaptchaId: Boolean($("#captchaId").text()),
				hasCaptchaInput: Boolean($("#captchaUserInput").val()),
			});
			if (callArgs.cmd === "login") {
				if (captchaMode === "google") {
					if (!googleSiteKey) {
						safeLoginStatus(__("Captcha is not configured."), "red");
						return Promise.resolve();
					}
					return loadGoogleScript(googleSiteKey)
						.then(function () {
							return window.grecaptcha.execute(googleSiteKey);
						})
						.then(function (token) {
							callArgs.token = token;
							debugLog("Google token attached", { hasToken: Boolean(callArgs.token) });
							return originalLoginCall(
								callArgs,
								function (response) {
									debugLog("Login callback received", {
										hasResponse: Boolean(response),
										hasExc: Boolean(response && response.exc),
										hasServerMessages: Boolean(response && response._server_messages),
									});
									const payload = parseCaptchaPayload(response);
									if (payload) {
										showLocalCaptcha(payload, payload.message);
									} else if (!(response && response.exc)) {
										clearLocalCaptcha();
									}
									if (callback) {
										callback(response);
									}
								},
								callUrl
							);
						})
						.catch(function (error) {
							debugWarn("Google captcha execution failed", error);
							safeLoginStatus(__("Captcha validation failed."), "red");
							return Promise.resolve();
						});
				} else if (captchaMode === "local") {
					const localCaptchaId = ($("#captchaId").text() || "").trim();
					const localCaptchaInput = ($("#captchaUserInput").val() || "").trim();
					if (!localCaptchaId || !localCaptchaInput) {
						debugWarn("Local captcha missing during submit");
						if (!localCaptchaId) {
							fetchLocalCaptcha(__("Captcha is required for this step."));
						}
						setCaptchaMessage(__("Please enter captcha."));
						return Promise.resolve();
					}
					callArgs.captcha_id = localCaptchaId;
					callArgs.captcha_user_input = localCaptchaInput;
					debugLog("Local captcha attached", {
						captchaId: localCaptchaId,
						inputLength: localCaptchaInput.length,
					});
				}
			}

			return originalLoginCall(
				callArgs,
				(response) => {
					debugLog("Login callback received", {
						hasResponse: Boolean(response),
						hasExc: Boolean(response && response.exc),
						hasServerMessages: Boolean(response && response._server_messages),
					});
					const payload = parseCaptchaPayload(response);
					if (payload) {
						showLocalCaptcha(payload, payload.message);
					} else if (!(response && response.exc)) {
						clearLocalCaptcha();
						// Captcha is one-time-use; prefetch next challenge for OTP step/login retry.
						if (captchaMode === "local") {
							fetchLocalCaptcha(__("Please enter captcha to continue."));
						}
					}
					if (callback) {
						callback(response);
					}
				},
				callUrl
			);
		};
	}

	function setupLocalModeCoreHooks() {
		debugLog("Setting up local mode hooks");
		// Keep core flow on the normal login.call path.
		// Our patched login.call injects local captcha fields automatically.
		window.isCaptchaEnabled = 0;
		window.siteKey = window.siteKey || "";
		debugLog("Local mode set: core captcha branch disabled");
	}

	function initializeCaptchaMode() {
		let context = { mode: "none" };
		frappe.call({
			method: "frappe_extensions.overrides.login.login.get_login_captcha_context",
			type: "POST",
			quiet: true,
			callback: function (response) {
				context = (response && response.message) || context;
				debugLog("Fetched captcha context", context);
				captchaMode = context.mode || "none";
				debugLog("Resolved captcha mode", captchaMode);
				if (captchaMode === "google") {
					googleSiteKey = context.site_key || "";
				} else if (captchaMode === "local") {
					setupLocalModeCoreHooks();
					bindRefreshHandler();
					if (context.captcha) {
						showLocalCaptcha(context.captcha, __("Captcha is required."));
					} else {
						ensureLocalCaptchaContainer();
					}
				}
				patchLoginCall();
			},
			error: function (error) {
				debugWarn("Failed fetching captcha context", error);
				captchaMode = "none";
				patchLoginCall();
			},
		});
	}

	initializeCaptchaMode();
	patchMsgprintForCaptcha();
	patchRequestCleanupForCaptcha();
	$(document).on("focus.feLoginCaptcha", "#login_token", function () {
		if (captchaMode === "local" && !(($("#captchaId").text() || "").trim())) {
			debugLog("OTP token focused without captcha, fetching challenge");
			fetchLocalCaptcha(__("Captcha is required for OTP verification."));
		}
	});
	$(document).on("login_rendered", function () {
		debugLog("login_rendered event fired");
		if (captchaMode === "local") {
			setupLocalModeCoreHooks();
			bindRefreshHandler();
			if (!(($("#captchaId").text() || "").trim())) {
				fetchLocalCaptcha(__("Captcha is required."));
			}
		}
		patchLoginCall();
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootstrapFeLoginCaptcha);
} else {
	bootstrapFeLoginCaptcha();
}
